import { EmptyAndMissingFile } from '@/assets';
import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import { PdfViewer } from '@/components/pdfViewer';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './Dialog.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  url: string;
};

export const MainPreview: FC<Props> = memo((props) => {
  return (
    <SuspenseErrorBoundary>
      <InnerMainPreview {...props} />
    </SuspenseErrorBoundary>
  );
});
MainPreview.displayName = 'MainPreview';

export const InnerMainPreview: FC<Props> = memo(({ url }) => {
  return (
    <div className={cx(styles['previewContainer'])}>
      <PdfViewer className={cx(styles['pdfViewerContainer'])} src={url} />
    </div>
  );
});
InnerMainPreview.displayName = 'MainPreview';

export const EmptyPreview: FC = memo(() => {
  const src = EmptyAndMissingFile;
  return <PdfViewer className={cx(styles['previewContainer'])} src={src} />;
});
EmptyPreview.displayName = 'EmptyPreview';
